/*
 * Public API Surface of zxing-scanner
 */

export * from './lib/zxing-scanner.module';
export * from './lib/zxing-scanner.component';
